import { render, staticRenderFns } from "./PopupPDF.vue?vue&type=template&id=5625d414&"
import script from "./PopupPDF.vue?vue&type=script&lang=js&"
export * from "./PopupPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports